/** Overview "Billing" card — credit balance from /waf/billing/credit. */
import { Card, CardHeader, CardTitle, CardBody, Skeleton } from '@vnetwork/ui/primitives';
import { useWafCredit } from '@/api/waf';
import { fmtUsd } from './format';
import styles from './WafDashboard.module.css';

export function BillingCard({ serviceId }: { serviceId: string }) {
  const q = useWafCredit(serviceId);
  const c = q.data;
  const pct = c && c.limit > 0 ? Math.min(100, (c.used / c.limit) * 100) : 0;
  return (
    <Card>
      <CardHeader>
        <CardTitle>Billing</CardTitle>
      </CardHeader>
      <CardBody>
        {q.isPending ? (
          <Skeleton style={{ height: 90 }} />
        ) : !c ? (
          <span style={{ color: 'var(--vn-fg-muted)', fontSize: 13 }}>No billing data.</span>
        ) : (
          <>
            <p className={styles.billingLine}>Unbilled usage: <strong>{fmtUsd(c.unbilled)}</strong></p>
            <p className={styles.billingLine}>Credit limit: <strong>{fmtUsd(c.used)} / {Math.round(c.limit)}</strong></p>
            <div className={styles.bar}>
              <div className={styles.barFill} style={{ width: `${pct}%` }} />
            </div>
            <p className={styles.billingLine}>
              Free credit {fmtUsd(c.free_credit)}{' '}
              <span style={{ color: 'var(--vn-fg-muted)' }}>({c.free_credit_expired} days left)</span>
            </p>
          </>
        )}
      </CardBody>
    </Card>
  );
}

export default BillingCard;
